// extracted by mini-css-extract-plugin
export default {"CloseBtn":"CloseBtn_vBm6V"};